import lessonApi from 'Api/axios/lesson-api';
import { useEffect, useState } from 'react';
import { LessonI } from 'types';

interface Props {
  init?: boolean;
  lessonId: string;
}

const useLessonApi = ({ lessonId, init = false }: Props) => {
  const [data, setData] = useState<LessonI | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const getLesson = async (lessonId: string) => {
    const response = await lessonApi.getLesson(lessonId);
    setData(response.data);
    setLoading(false);
    setError(response.error);
  };

  useEffect(() => {
    if (init === true && lessonId) {
      getLesson(lessonId);
    }
  }, [init, lessonId]);

  return {
    data,
    loading,
    error,
    getLesson,
  };
};

export default useLessonApi;
